// src/app/core/auth/oidc-auth.config.ts
import { HttpClient } from '@angular/common/http';
import { LogLevel, OpenIdConfiguration, StsConfigHttpLoader, StsConfigLoader } from 'angular-auth-oidc-client';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IVendorCatalogClientConfig, OidcJson } from '../../config/config-service';

// Stabile Flags, die unabhängig von der Umgebung gelten. Umgebungsabhängige Werte
// (authority/clientId/scope/postLogoutRedirectUri/...) kommen zur Laufzeit aus
// assets/config/config.<env>.json (oidc-Sektion, siehe IVendorCatalogClientConfig).
export const DEFAULT_OIDC: Partial<OpenIdConfiguration> = {
  responseType: 'code',
  silentRenew: true,
  renewTimeBeforeTokenExpiresInSeconds: 10,
  useRefreshToken: false,
  logLevel: LogLevel.Warn,
  ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
  triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
  autoUserInfo: true,
  renewUserInfoAfterTokenRenew: true,
};

/**
 * Lädt die OIDC-Konfiguration zur Laufzeit aus assets/config/config.<env>.json, damit ein
 * Profilwechsel (z. B. Authority local↔staging) ohne Angular-Rebuild wirkt. Die JSON-Sektion
 * `oidc` wird über DEFAULT_OIDC gelegt; window.location.origin-abhängige Werte (redirectUrl,
 * silentRenewUrl) bleiben Code-Defaults, damit sie pro Origin korrekt bleiben.
 */
export function authConfigLoaderFactory(http: HttpClient): StsConfigLoader {
  const config$ = http
    .get<IVendorCatalogClientConfig>(`./assets/config/config.${environment.configEnv}.json`)
    .pipe(
      map(({ oidc }) => {
        const { redirectPath, ...oidcConfig } = (oidc ?? {}) as Partial<OidcJson>;
        return {
          ...DEFAULT_OIDC,
          ...oidcConfig,
          redirectUrl: `${window.location.origin}${redirectPath ?? ''}`,
          silentRenewUrl: `${window.location.origin}/silent-renew.html`,
        } as OpenIdConfiguration;
      })
    );

  return new StsConfigHttpLoader(config$);
}
